module.exports = __webpack_public_path__ + "img/68.bb3ed16e.png";